import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-03-29'
        tag='Facebook Marketplace'
        title="Items You Can't Sell on Facebook Marketplace"
      >
        <p>
          Facebook is the world's largest social media platform with over 2 billion monthly active users. Facebook
          marketplace, an app for buying and selling goods on Facebook, has become a hub for sellers to post their
          products and services.
        </p>
        <p>
          It's important to note that not all items are allowed on the site. Sellers who violate these community
          standards and policies will have their listings removed and get a penalty that includes warning letters from
          Facebook or being blocked from accessing the marketplace.{' '}
        </p>
        <p>
          The marketplace has strict rules on what can be sold, so it's important to make sure you know the restrictions
          before listing your item. The following will discuss prohibited items on Facebook Marketplace and how to
          appeal if your listing was mistakenly removed.
        </p>

        <h3>Restricted Items and Services on Facebook Marketplace </h3>
        <p>
          Facebook has implemented many changes to become a more viable platform for business owners in the past year.
          They've started advertising new features and creating special pages for businesses to promote their products.
          They have been working hard to remove prohibited items from being sold on their marketplace in recent months.{' '}
        </p>
        <p>
          The following items are restricted to be sold on Facebook Marketplace. However, Facebook allows discussions
          about the sale of these goods in their physical store, website, or by online retailers.{' '}
        </p>
        <p>Here is an overview of prohibited items on Facebook Marketplace together with its exceptions:</p>
        <h4>Weapons and Firearms</h4>
        <p>
          Facebook does not allow any content that promotes the buy, sell, donation, and trade of firearms, explosives,
          and weapons. This includes but is not limited to:{' '}
        </p>
        <ul>
          <li>Firearms and their parts </li>
          <li>Ammunition</li>
          <li>Explosives </li>
          <li>Paintball guns and BB guns</li>
          <li>Fireworks</li>
          <li>Pepper Spray and Tasers</li>
          <li>Gun Ranges and Gun Shows</li>
          <li>Providing access to 3D printing for manufacturing firearms or firearms parts regardless of context. </li>
        </ul>
        <p>
          <strong>Exception:</strong>
        </p>
        <ul>
          <li>The content is for education or promoting safety training.</li>
          <li>The content is education or discussion of licenses for legal weapons.</li>
          <li>
            Donating, trading, auctioning, promoting, and sharing contents of firearms, firearm parts, ammunition, and
            explosives should only be done by a Page, Group, or Private individual sharing content on behalf of
            legitimate brick-and-mortar entities. (i.e., retail businesses, websites, brands, government agencies,
            government-affiliated organizations){' '}
          </li>
        </ul>
        <h4>Illegal Drugs, Prescription or Recreational Drugs, and Other Drug Paraphernalia </h4>
        <p>
          Any content promoting the buy, sell, or trade of illegal drugs, prescription drugs, and other drug
          paraphernalia is strictly prohibited. This includes but is not limited to:{' '}
        </p>
        <ul>
          <li>Marijuana and other marijuana products </li>
          <li>Prescription Drugs </li>
          <li>Other drug paraphernalia include bongs, miniature spoons, and various pipes. </li>
        </ul>
        <p>
          <strong>Exception: </strong>
        </p>
        <ul>
          <li>
            Listing the prices of pharmaceutical drugs such as vaccines for education or discussion context. (i.e.,
            affordability, efficacy, accessibility){' '}
          </li>
          <li>
            Listing offering delivery pharmaceutical drugs posted by legitimate healthcare e-commerce or
            brick-and-mortar entities.{' '}
          </li>
        </ul>
        <h4>Alcohol and Tobacco Products </h4>
        <p>
          Facebook does not allow any content that promotes the buy, sell, donation, and trade of alcohol, tobacco
          products, and related paraphernalia. This includes but is not limited to:{' '}
        </p>
        <ul>
          <li>Alcoholic beverages</li>
          <li>Kits for Making Alcohol</li>
          <li>Cigarettes, Electronic Cigarettes, Cigars, and Chewing Tobacco </li>
          <li>Tobacco Pipes and Paraphernalia </li>
          <li>Bongs and Hookahs</li>
          <li>Tobacco rolling machines and Rolling papers </li>
        </ul>
        <p>
          <strong>Exceptions: </strong>
        </p>
        <ul>
          <li>Apparel designs with a tobacco or tobacco brand logo. </li>
          <li>Apparel designs with alcohol or alcohol brand logo</li>
          <li>Other alcohol-related items (Wine glasses, coolers, wine bottle openers/holders) </li>
          <li>
            Content refers to any alcohol/tobacco that will be consumed on location at a brick-and-mortar restaurant,
            events, bar, party, etc.{' '}
          </li>
          <li>
            A page posts content, group, or private individual representing legitimate brick-and-mortar entities on
            their behalf (i.e., website, retail businesses){' '}
          </li>
        </ul>
        <h4>Unsafe Supplements and Weight Loss Products </h4>
        <p>
          Any content that promotes buying, selling, or donating unsafe indigestible supplements and weight loss
          products are strictly not allowed on the platform.{' '}
        </p>
        <p>
          Unsafe supplements are determined by Facebook and under its sole discretion. This includes but is not limited
          to:{' '}
        </p>
        <ul>
          <li>Steroids (Anabolic)</li>
          <li>Chitosan </li>
          <li>Human Growth Hormones</li>
          <li>Comfrey </li>
          <li>Dehydroepiandrosterone </li>
          <li>Ephedra </li>
          <li>Miracle claims from weight-loss products/supplements </li>
        </ul>
        <p>
          <strong>No Exceptions </strong>
        </p>
        <h4>Animals and Wildlife </h4>
        <p>
          Contents that encourage buying, selling, trading, or donating any animals, including endangered and
          non-endangered animals, are prohibited from being listed on Facebook Marketplace. This includes but is not
          limited to:{' '}
        </p>
        <ul>
          <li>Live animals, wildlife, and plants </li>
          <li>Pets and Livestock </li>
          <li>Any animal parts or skin, including fur</li>
          <li>Content engaging in the poaching of endangered and non-endangered animals and their parts. </li>
          <li>Provides instructions on using or making products from endangered species or their parts. </li>
        </ul>
        <p>
          <strong>Exceptions: </strong>
        </p>
        <ul>
          <li>Content for rehoming or peer-to-peer adoptions of pets or live non-endangered animals.</li>
          <li>Content for lost pets (i.e., offering rewards) </li>
          <li>Contents that promotes the sale of animal products (cages, collars, toys) </li>
          <li>Content offering Veterinary, grooming, and boarding services. </li>
          <li>
            A page posts content that encourages to buy, sell, or trade, group, or private individual representing
            legitimate brick-and-mortar entities on their behalf (i.e., website, retail businesses){' '}
          </li>
        </ul>
        <h4>Adult Products or Sexual Services </h4>
        <p>
          Any listing promoting the sale or use of adult products and services is not allowed in Facebook Marketplace.
          This includes but is not limited to:{' '}
        </p>
        <ul>
          <li>Sexual products (i.e., toys, enhancement) </li>
          <li>Videos or Shows for adult entertainment</li>
        </ul>
        <p>
          <strong>Exceptions: </strong>
        </p>
        <ul>
          <li>
            Content educating or discussing family planning and contraception. Including its affordability and
            accessibility.{' '}
          </li>
        </ul>
        <h4>Healthcare Products, Medical Devices, and Services </h4>
        <p>
          Any posts that attempt to buy, sell or trade that imply a negative self-perception to promote diet, weight
          loss, or other health-related products are strictly prohibited. Content should also not depict any "before and
          after" images with unexpected or unlikely results.{' '}
        </p>
        <p>This includes the following but is not limited to: </p>
        <ul>
          <li>Smoking Cessation products containing Nicotine </li>
          <li>Contact Lenses </li>
          <li>Bandages and Braces </li>
          <li>Medical testing kits (i.e., virus, diseases) </li>
          <li>Thermometers </li>
          <li>First-aid kits </li>
        </ul>
        <p>
          <strong>Exceptions: </strong>
        </p>
        <ul>
          <li>Lifestyle and fitness accessories (i.e, smartwatches) </li>
        </ul>
        <h4>Human Body Parts and Fluids </h4>
        <p>
          Any content or posts promote buying, selling, trade, or donating human body parts or fluids. This includes the
          following but is not limited to:{' '}
        </p>
        <ul>
          <li>Human Blood</li>
          <li>Urine and Sputum </li>
          <li>Human Body Parts (i.e., eyes, tongue) </li>
          <li>Human tissue and organs </li>
        </ul>
        <p>
          <strong>Exceptions: </strong>
        </p>
        <ul>
          <li>Hair extensions </li>
          <li>Wigs made from human hair </li>
        </ul>
        <h4>Historical Artifacts </h4>
        <p>Any listings that promote buying, selling, trade, or donating historical artifacts are not allowed. </p>
        <p>This includes but is not limited to:</p>
        <ul>
          <li>Stone tools</li>
          <li>Pottery</li>
          <li>Metal objects (i.e., weapons)</li>
          <li>Personal items of famous personality (i.e., buttons, clothing, jewelry)</li>
        </ul>
        <p>
          <strong>Exceptions: </strong>
        </p>
        <ul>
          <li>The content encourages education or discussion about historical artifacts. </li>
          <li>If the artifacts are for fictional or documentary context. </li>
        </ul>
        <h4>Digital Media, Subscriptions, or Digital Products </h4>
        <p>
          Post that promotes the sale, trade, or donation of downloadable digital content, subscriptions, accounts are
          not allowed. Specific digital media and electronic devices that facilitate or encourage unauthorized digital
          content streaming are also prohibited.{' '}
        </p>
        <p>This includes but is not limited to the following: </p>
        <ul>
          <li>Downloadable digital content (i.e., PDFs, music, games, movies, etc.) </li>
          <li>Digital accounts (i.e., Games, movie streaming accounts) </li>
          <li>Digital subscriptions and internet streaming services</li>
          <li>Digital coupons</li>
          <li>Sale of streaming devices with unauthorized access to content</li>
          <li>Wiretapping devices </li>
        </ul>
        <p>
          <strong>Exceptions:</strong>
        </p>
        <ul>
          <li>Sale of authentic audio or video CDs, DVDs, and Blu Ray </li>
          <li>Sale of authorized digital devices (i.e., smartphones, TVs, consoles)</li>
          <li>Streaming device equipment (i.e., keyboards, remotes, mouse) </li>
        </ul>
        <h4>Other things that are not allowed: </h4>
        <ul>
          <li>Items that are not physical products (i.e., lost and found posts, jokes, news)</li>
          <li>Photos that do not match the cover photo and its title and description </li>
          <li>
            Listings the wrongfully discriminate against people or have hateful, misleading, and violent content (i.e.,
            race, ethnicity, color, nationality, citizenship, religion, sex, age, gender, etc.){' '}
          </li>
          <li>
            Documents, Currency, and Financial Instruments (i.e., cryptocurrency, virtual currency, fake documents)
          </li>
          <li>Any listings that promote or facilitate online gambling (i.e., gaming, lotteries, casino)</li>
          <li>Third-Party Infringement (i.e., copyright, trademark)</li>
          <li>Used cosmetics (Sold not in their original packaging)</li>
          <li>Stolen Goods</li>
        </ul>

        <p>
          All items listed for sale on Facebook must adhere to Commerce Policies. These policies must apply to the
          following:{' '}
        </p>
        <ul>
          <li>Buy and Sell Groups (Public and Private Groups) </li>
          <li>Instagram Shops</li>
          <li>Marketplace</li>
          <li>Page Shops </li>
          <li>
            Commerce policies and rules provide a list of restrictions on the type of products and services allowed on
            Facebook, Instagram, and WhatsApp. Everyone must follow this set of policies to avoid any complications and
            protect the users of Facebook Marketplace.
          </li>
        </ul>

        <h3>Seller Penalty </h3>
        <p>
          All listing must go through a series of reviews by the Facebook team and comply with Facebook's Community
          Standards. These guidelines and standards apply to all products sold on Facebook, Instagram, and WhatsApp.{' '}
        </p>
        <p>
          Sellers who fail to comply with these policies and guidelines may face severe consequences, including but not
          limited to the following:{' '}
        </p>
        <ul>
          <li>Removal of posted listings </li>
          <li>Unable to use product tags</li>
          <li>Suspension of access to Facebook, Instagram, or WhatsApp</li>
          <li>Termination of access to Facebook, Instagram, or WhatsApp and its features. </li>
        </ul>
        <p>
          Facebook will first send you a warning letter to notify you of your violation. If you repeatedly post content,
          product, and services that violate Commerce policies. Additional action may be taken against your account,
          which may result in being blocked from using Facebook, Instagram, or WhatsApp entirely.{' '}
        </p>

        <h3>How to Appeal the Decision</h3>
        <p>
          There are instances wherein the seller may feel that their case has been unfairly handled or there has been a
          mistake in removing the listing. If this is the case, you can file an appeal to the decision, and the Facebook
          team will take a second look.{' '}
        </p>
        <p>Here is a step-by-step process on how to appeal the decision on Marketplace: </p>
        <ol>
          <li>Before sending an appeal. Make sure your item is not on the list of prohibited items and services. </li>
          <li>Fill up the appeal form </li>
          <li>Click the "send" button to make your appeal </li>
          <li>Check your listing in about 24 hours to see if the request has been approved</li>
        </ol>
        <p>
          Suppose the appeal has been disapproved again. Please review the Commerce Policies again and make sure you
          comply with the rules. Listing restricted goods and services frequently can result in the suspension of your
          account or access removal in the marketplace.{' '}
        </p>
        <p>
          If you think you did not violate any policies or standards but still cannot access Marketplace, here's a
          step-by-step guide on how to contact the Facebook Marketplace team.{' '}
        </p>
        <ol>
          <li>Sign in to your account and click the Marketplace logo in the menu </li>
          <li>Select "Request Review" and fill out the form. </li>
          <li>Check your "Support Inbox" or your email address linked with your Facebook account for updates. </li>
        </ol>
        <p>
          Your appeal will be reviewed, and you will get a response within 24 hours from the Facebook team. If your
          request was approved and your access has been restored, you may need to refresh your web browser (if you're
          using a desktop) or re-install the app (if you're using mobile.){' '}
        </p>

        <h3>In a Nutshell: </h3>
        <p>
          It is essential to be responsible for everything we do as a seller. This includes complying with the rules,
          guidelines, and standards on marketplaces and platforms we use. Although these can be overwhelming and
          time-consuming, it's part of our reselling business.{' '}
        </p>
        <p>
          We suggest keeping a note or bookmarking these policies and guidelines to guide you and prevent unwanted
          circumstances from happening. Suppose you have problems managing your time, monitoring your listing, or
          preparing items for shipping and delivery. Having a trusted bot is the answer.{' '}
        </p>
        <p>
          A bot act as your marketing expert and automates listing tasks such as sharing, liking, and following to save
          you time to do more important things. On top of it, OneShop also has re-listing and cross-listing features to
          help you have a smooth and seamless reselling business.{' '}
        </p>
        <p>
          <a href='https://tools.oneshop.com/signup'>Sign-up</a> here and bring your reselling game to the next level!
          To learn more, visit <a href='https://tools.oneshop.com/'>https://tools.oneshop.com/</a>.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
